import { track } from '@root/initializers/wt';

import { gtm } from '@utils/gtm';

export enum ProductType {
  SMART_STORAGE = 'smart_storage',
  MOVING = 'moving',
}

export type IThirdPartyEventParams = {
  visitor_token?: string;
  product_type?: ProductType | null;
  zip_code?: string;
  promo_name?: string;
  checkout_version?: string | null;
  value?: string | number;
  currency?: 'CAD' | 'USD';
  orderID?: string | null;
  name?: string;
  phone?: string;
  email?: string;
  date_preferred?: string;
  date_scheduled?: string;
  protection_plan_amount?: number;
  protection_plan_name?: string;
  protection_plan_tax?: number;
  protection_term_revenue?: number;
  storage_plan_amount?: number;
  storage_plan_name?: string;
  storage_plan_tax?: number;
  storage_term_revenue?: number;
  total_guaranteed_revenue?: number;
  onboarding_fee_amount?: number;
  final_fee_amount?: number;
  gas_fee_amount?: number;
  bundle_fee_amount?: number;
  total_fee_amount?: number;
  term_length?: number;
  disposal?: boolean;
};

export enum EventName {
  INITIATE_FLOW = 'InitiateFlow',
  CHECKOUT = 'Checkout',
  RESERVE_CLICKED = 'ReserveClicked',
  LEAD_FORM_FILL = 'LeadFormFill',
  ADD_PAYMENT_INFO = 'AddPaymentInfo',
  DATE_PREFERRED = 'DatePreferred',
  AVAILABILITY = 'Availability',
}

export const createThirdPartyConversionEvent = (
  name: EventName,
  metadata?: IThirdPartyEventParams,
) => {
  gtm({
    event: name,
    ...metadata,
  });

  track({
    metadata,
    action: 'external_pixel_trigger',
    label: name,
  });
};
